/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import BankDetails from "../../../../../components/_utils/AccountCreationComponents/BankDetails";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import AssociateAccountBankEdit from "../../../BeneficiaryEditAccount/AssociateAccountBankEdit";
import ICONS from "../../../../../assets/Icons";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import ReimbursementAccountDetailsPopup from "../../../../../components/_utils/ReimbursementAccountDetailsPopup";

const ReimbursementBankEdit = ({
  beneLookLoading,
  setBankLookupNext,
  bankLookupNext,
  BenEnableNextButton,
  payload,
  setPayload,
  activeStep,
  setBankIsArchived,
  setBankIsApproved,
  setBankIsDennied,
  setBankIsRejected,
  setBankIsPending,
  bankAccountType,
  setBankAccountType,
  active,
  setActive,
  newBankMessage,
  setBankNewMessage,
  hideBankCreate,
  previousBankID,
  createNewedit,
  setCreateNewEdit,
  bankUnachivedOpenPop,
  bankAchivedOpenPop,
  timer,
  benebankLookData,
  isIFSCValid,
  isBankLinkedAccount,
}) => {
  const isBankError = useSelector(
    (state) => state.beneAllVerification.isBankError,
  );

  const bankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const bankStatus = useSelector(
    (state) => state.beneAllVerification.verifyBank,
  );
  const [virtualAccount, setVirtualAccount] = useState(false);
  const [bankNonArchive, setBankNonArchive] = useState(false);
  const [activeTab, setActiveTab] = useState("Active");
  const [slideDirection, setSlideDirection] = useState("right");
  const [remDetails, setRemDetails] = useState(false);
  const [remAccountId, setRemAccountId] = useState("");

  const associatedAccountRef = useRef(null);

  let haveAcheived = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "archived";
  });
  let haveApproved = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });
  let haveDennied = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "denied";
  });
  let haveRejected = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "rejected";
  });
  let havePending = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBlock = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "blocked";
  });

  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);

  useEffect(() => {
    if (bankAchivedOpenPop || bankUnachivedOpenPop) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [bankAchivedOpenPop, bankUnachivedOpenPop]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      event.stopPropagation();
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [associatedAccountRef]);

  useEffect(() => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      if (
        payload.bank_account !== payload.old_bank_account &&
        bankStatus?.status === true
      ) {
        BenEnableNextButton(false);
      }
      if (isBankError === true) {
        BenEnableNextButton(true);
        setCreateNewEdit(true);
      }
      if (
        bankStatus?.verification_details[0].account_exists === "N" &&
        !bankLookData
      ) {
        BenEnableNextButton(false);
        setCreateNewEdit(true);
      }
      if (payload.bank_account === payload.old_bank_account) {
        setCreateNewEdit(false);
        setBankNewMessage(true);
      }
      if (payload.bank_account !== payload.old_bank_account) {
        setCreateNewEdit(true);
      }
      if (!payload.bank_account || !payload.ifsc_code) {
        BenEnableNextButton(true);
      }
      if (payload.ifsc_code.length < GlobalConfiguration.ifscLength) {
        BenEnableNextButton(true);
      }
    }
  }, [bankLookData, isBankError, bankStatus, payload]);

  useEffect(() => {
    if (activeTab === "Active") {
      setActive(false);
      setBankIsDennied(false);
      setBankIsRejected(false);
      setBankIsApproved(false);
      setBankIsArchived(false);
      setBankIsPending(false);
    } else if (activeTab === "Inactive") {
      setActive(true);
      setBankIsDennied(false);
      setBankIsRejected(false);
      setBankIsApproved(false);
      setBankIsArchived(false);
      setBankIsPending(false);
    }
  }, [activeTab]);

  const ActiveData = () => {
    setActive(false);
    setBankIsDennied(false);
    setBankIsRejected(false);
    setBankIsApproved(false);
    setBankIsArchived(false);
    setBankIsPending(false);
    setBankAccountType({
      type: "",
      id: "",
    });
    setBankNonArchive(false);
    setBankNewMessage(true);
    if (activeTab === "Inactive") setSlideDirection("left");
    setActiveTab("Active");
  };

  const DeactiveData = () => {
    if (activeTab === "Active") setSlideDirection("right");
    setActiveTab("Inactive");

    setActive(true);
    setBankIsDennied(false);
    setBankIsRejected(false);
    setBankIsApproved(false);
    setBankIsArchived(false);
    setBankIsPending(false);
    setBankAccountType({
      type: "",
      id: "",
    });
    setBankNonArchive(false);
    setBankNewMessage(true);
  };

  const addSpacesToNumber = (number) => {
    return number.replace(/(.{4})/g, "$1 ").trim();
  };

  const details =
    !beneLookLoading &&
    benebankLookData?.status === undefined &&
    !isBankError &&
    isIFSCValid &&
    virtualAccount;

  return (
    <>
      {remDetails && (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
            <ReimbursementAccountDetailsPopup
              closeBeneAccountDetailModal={() => {
                setRemDetails(false);
              }}
              reimburse_account_id={remAccountId}
              type={"reimburseacc_details"}
            />
          </div>
        </>
      )}
      <div className="beneBank_Main">
        <CommonLayout>
          <div className="w-width-full">
            {bankAccountType.type === "blocked" &&
            !isBankError &&
            !virtualAccount ? (
              <div className="bene_block_message_text">
                <img
                  src={ICONS?.ERROR_WHITE_CIRCLE}
                  alt="info"
                />
                <p>To unblock this account, please contact customer support</p>
              </div>
            ) : isBankLinkedAccount && isIFSCValid ? (
              <div className=" flex bg-emphasis p-padding-md mb-margin-md rounded-border-radius-md">
                <p className=" text-text-secondary text-font-xs font-normal ">
                  Looks like this bank account is already linked to the PAN
                  provided. Please change the provided bank details to proceed.
                </p>
              </div>
            ) : hideBankCreate &&
              !isBankError &&
              !newBankMessage &&
              isIFSCValid &&
              !virtualAccount ? (
              <div className="bene_new_message_text_block">
                <img
                  src={ICONS?.ERROR_WHITE_CIRCLE}
                  alt="info"
                />
                <p>
                  Creating a new account will transform this account into a
                  joint account since there are several PANs associated with it
                  and adds it to the active accounts for the provided Bank
                  details.
                </p>
              </div>
            ) : createNewedit &&
              !isBankError &&
              isIFSCValid &&
              !virtualAccount &&
              timer &&
              bankVerificationStatus ? (
              <div className=" p-padding-md mb-margin-md rounded-border-radius-md bg-emphasis flex">
                <p className=" text-text-secondary text-font-xs font-normal">
                  Updating the bank details will transform this account into a
                  joint account since there are several PANs associated with it
                  and adds it to the active accounts for the provided bank
                  details.
                </p>
              </div>
            ) : bankNonArchive &&
              !isBankError &&
              isIFSCValid &&
              !createNewedit ? (
              <div className="bank_new_message_text_block_nonarchive"></div>
            ) : null}

            {virtualAccount && isIFSCValid && createNewedit ? (
              <div className="flex flex-row gap-x-gap-sm bg-emphasis p-padding-md rounded-border-radius-md mb-margin-md">
                <img
                  src={ICONS.VIRTUAL_ACCOUNT}
                  alt="Virtual Account"
                  className="w-icon-md h-icon-md"
                />
                <div className="flex flex-col gap-y-gap-sm">
                  <p className="text-font-sm text-text-primary font-semibold">
                    Virtual Account Detected
                  </p>
                  <ul className="flex flex-col gap-y-gap-sm list-disc list-inside ml-margin-xs">
                    <li className="text-font-xs text-text-primary font-normal">
                      Account could not be verified as it is virtual account.
                    </li>
                    <li className="text-font-xs text-text-primary font-normal">
                      Please self verify and proceed with caution.
                    </li>
                  </ul>
                </div>
              </div>
            ) : null}
            <div className=" h-fit w-full">
              <BankDetails
                payload={payload}
                setPayload={setPayload}
                BenEnableNextButton={BenEnableNextButton}
                activeStep={activeStep}
                setVirtualAccount={setVirtualAccount}
                bankLookupNext={bankLookupNext}
                setBankLookupNext={setBankLookupNext}
                bankVerificationStatus={bankVerificationStatus}
                setBankVerificationStatus={setBankVerificationStatus}
                virtualAccount={virtualAccount}
                isIFSCValid={isIFSCValid}
                setBankUserInfo={(e) => {}}
              />
            </div>
          </div>
          {bankVerificationStatus === true ? (
            <>
              <AssociateAccountBankEdit
                ActiveData={ActiveData}
                DeactiveData={DeactiveData}
                haveAcheived={haveAcheived}
                haveDennied={haveDennied}
                haveBlock={haveBlock}
                haveRejected={haveRejected}
                isApprovedState={benebankLookData?.beneficiary_accounts}
                haveApproved={haveApproved}
                havePending={havePending}
                isActive={active}
                activeTab={activeTab}
                setSlideDirection={setSlideDirection}
                slideDirection={slideDirection}
                setActiveTab={setActiveTab}
                previousId={previousBankID}
                addSpacesToNumber={addSpacesToNumber}
                beneLookLoading={beneLookLoading}
                details={details}
                payload={payload}
                isBankLinkedAccount={isBankLinkedAccount}
                type="ReimbursementBankDetails"
                setAccountId={setRemAccountId}
                setAccoutDetails={setRemDetails}
              />
            </>
          ) : (
            <div
              className="dividepan bank_Details_Edit"
              style={{
                visibility: "hidden",
              }}
            ></div>
          )}
        </CommonLayout>
      </div>
    </>
  );
};
export default ReimbursementBankEdit;
